import React from 'react';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import moment from 'moment';
import classNames from 'classnames';

export default ({ data, title, tasksTouched }) => {
    return data.length > 0 ? (
        <span>
            <ReactTable
                data={data}
                columns={[
                    {
                        Header: '',
                        accessor: 'id',
                        className: 'hidden',
                        width: 0
                    },
                    {
                        Header: props => (
                            <div>
                                {title}&nbsp;
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        ),
                        accessor: 'name',
                        Cell: props => {
                            return (
                                <div>
                                    <span className="table__cell-title">
                                        Name
                                    </span>

                                    <Link
                                        to={`/event/${props.original.id}`}
                                        // className="table__cell-link"
                                        className={classNames(
                                            'table__cell-link',
                                            {
                                                'table__cell--bold':
                                                    props.original.newTask &&
                                                    !tasksTouched
                                            }
                                        )}
                                    >
                                        {props.value}
                                    </Link>
                                </div>
                            );
                        }
                    },
                    {
                        Header: props => (
                            <div>
                                Due Date&nbsp;
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        ),
                        accessor: 'dueDate',
                        Cell: props => (
                            <div>
                                <span className="table__cell-title">
                                    Due Date
                                </span>
                                <span
                                    className={classNames('table__cell', {
                                        'table__cell--bold':
                                            props.original.newTask &&
                                            !tasksTouched
                                    })}
                                >
                                    {props.value}
                                </span>
                            </div>
                        )
                    },
                    {
                        Header: props => (
                            <div>
                                Assigned Date&nbsp;
                                <svg className="icon icon-sort">
                                    <use xlinkHref="#icon-sort" />
                                </svg>
                            </div>
                        ),
                        accessor: 'updatedAt',
                        Cell: props => (
                            <div>
                                <span className="table__cell-title">
                                    Assigned Date
                                </span>
                                <span
                                    className={classNames('table__cell', {
                                        'table__cell--bold':
                                            props.original.newTask &&
                                            !tasksTouched
                                    })}
                                >
                                    {moment(props.value).format('YYYY-MM-DD')}
                                </span>
                            </div>
                        )
                    }
                ]}
                defaultPageSize={data.length > 20 ? 20 : data.length}
                className="-striped -highlight alerts"
                showPagination={data.length > 20 ? true : false}
                defaultSorted={[
                    {
                        id: 'dueDate',
                        asc: 'true'
                    }
                ]}
                showPageSizeOptions={false}
            />
        </span>
    ) : null;
};



// WEBPACK FOOTER //
// ./src/components/alerts/tables/buildtable.js